import { fork, put, select, takeLatest } from 'redux-saga/effects';
import * as _ from 'lodash';

import listSaga from './list/list.saga';
import editSaga from './edit/edit.saga';
import createSaga from './create/create.saga';
import typeSaga from './type/type.saga';
import { FETCH_ALL_DESTINATION_REQUESTED, FETCH_ALL_DESTINATION_SUCCEEDED } from './destination.action';
import { API_CALL_ERROR } from '../../store/action';
import { takeEvery } from 'redux-saga/effects';
import { AppInjector } from '../../app-injector';
import { ApiService } from '../../api/api.service';

function* fetchAllDestination(action) {
  try {
    let result;
    let data = yield select(state => (state as any).Destination.all);
    if (action.refresh === true) {
      data.fetched = false;
    }
    if (data.fetched === true) {
      result = data.items;
    } else {
      result = yield AppInjector.get(ApiService)
        .destination.list({ scope: 'locations' })
        .toPromise();
    }
    if (!_.isUndefined(action.com)) {
      yield put({ type: FETCH_ALL_DESTINATION_SUCCEEDED, com: action.com, data: result });
    } else {
      yield put({ type: FETCH_ALL_DESTINATION_SUCCEEDED, data: result });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllDestinationRequested() {
  yield takeLatest(FETCH_ALL_DESTINATION_REQUESTED, fetchAllDestination);
}

export default _.map([...listSaga, ...editSaga, ...createSaga, ...typeSaga, watchFetchAllDestinationRequested], item => fork(item));
